import Super from 'ember-simplepractice/components/shared/signature/client-sign-here';
import styles from './client-sign-here-styles.module.scss';

export default class SharedSignatureClientSignHere extends Super {
  constructor() {
    super(...arguments);
    this.styles['signature-box'] += ' ' + styles['signature-box'];
  }
}
